(() => {
  const enhance = (root = document) => {
    root.querySelectorAll('[data-bcm-education-reading]').forEach((reading) => {
      if (reading.dataset.bcmEducationEnhanced === 'true') return;
      reading.dataset.bcmEducationEnhanced = 'true';
      const headings = Array.from(reading.querySelectorAll('h2')).filter((heading) => !heading.classList.contains('bcm-education-deck') && heading.textContent.trim() && heading.getClientRects().length);
      if (headings.length < 3) return;
      const details = document.createElement('details');
      details.className = 'bcm-education-contents';
      const summary = document.createElement('summary');
      summary.textContent = 'In this guide';
      const nav = document.createElement('nav');
      nav.setAttribute('aria-label', 'In this guide');
      const list = document.createElement('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) {
          let id = `bcm-guide-${index + 1}`;
          while (document.getElementById(id)) id += '-section';
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });
      nav.appendChild(list);
      details.append(summary, nav);
      reading.prepend(details);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
